import { Component } from "react";
import { Link } from 'react-router-dom';
import { USER_PROFILE_SIDEBAR, USER_STUDENT } from '../../helpers/constants';

class UserProfileSidebar extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        let pathname = this.props.pathname;
        console.log("pathname",pathname)
        return (
            <div className="sidebar-content">
                <ul>
                    {
                            this.props.user.profile && (this.props.user.profile === USER_STUDENT.key) && (
                                <>
                                    {
                                        USER_PROFILE_SIDEBAR.map((menu, index) => (
                                            <li key={`sidebar_menu_item_${index}`}>
                                                <Link to={menu.link} className={`${(pathname === menu.link) ? "active" : ""}`}>
                                                    <i className={`bx bx-${menu.icon}`} />
                                                    <span>{menu.label}</span>
                                                    <span>{menu.endIcon}</span>
                                                </Link>
                                            </li>
                                        ))
                                    }
                                </>
                            )
                        }
                </ul>
            </div>
        )
    }
}
export default UserProfileSidebar;